import React from 'react';
import {
  Dialog,
  DialogActions,
  createStyles,
  makeStyles,
  Card,
  IconButton,
} from '@material-ui/core';
import moment from 'moment';
import { DialogProps } from '@material-ui/core/Dialog';
import CloseIcon from './CloseIcon';
import { IContentTransaction } from '../../../../interfaces/transaction';
import { Button } from '../../../../components/other/Buttons';

interface IAlertTransactionDetail extends DialogProps {
  handleAgree?: any;
  handleClose?: any;
  message?: string;
  transaction: IContentTransaction | null
}

const useStyles = makeStyles(theme =>
  createStyles({
    container: {
      padding: '10 0 10px 10px',
      width: 700
    },
    paper: {
      overflowY: 'clip'
    },
    content: {
       height: 'auto', 
       maxHeight: 100, 
       justifyContent: 'space-between', 
       alignItems: 'center'
    },
    imgContainer: {
      height: 400,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        maxWidth: 280,
        height: 200,
      },
      [theme.breakpoints.only('sm')]: {
        maxWidth: 350,
        height: 250,
      },
    },
    itemContainer: {
      display: 'flex', 
      flexDirection: 'row', 
      alignItems: 'center', 
      justifyContent: 'space-between',
    },
    amountText: {
      fontSize: 16, 
      fontWeight: 400,
      color: '#1B1726',
    },
    nameText: {
      fontSize: 16, 
      fontWeight: 400,
      color: '#2A344873',
    },
    subTitle: {
      fontSize: 24, 
      fontWeight: 700, 
      marginTop: 40, 
      marginBottom: 20
    },
    title: {
      fontSize: 32,
      fontWeight: 700
    }
  })
);

interface IAlertItem {
  name: string
  amount: string
}

const AlertItem = ({name, amount}:IAlertItem) => {
  const classes = useStyles();
  return (
    <div className={classes.itemContainer}>
      <div>
        <p className={classes.nameText}>
          {name}
        </p>
      </div>

      <div>
        <p className={classes.amountText}>
          {amount}
        </p>
      </div>
    </div>
  )
}

const AlertTransactionDetail: React.FC<IAlertTransactionDetail> = ({
  open,
  handleClose,
  transaction,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      scroll='body'
    >
      <DialogActions style={{ overflow: 'hidden' }} >
        <div className={classes.container}>
          <div
            className={classes.imgContainer}
            style={{ 
              height: 'auto', 
              maxHeight: 100, 
              justifyContent: 'space-between', 
              alignItems: 'center' 
            }}
          >
            <p className={classes.title}>Transaction information</p>

            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          
          {transaction && (
            <Card style={{paddingRight: 10}}>
              <AlertItem name='Date' amount={moment(transaction.opened).format('DD.MM.YYYY')} />
              <AlertItem name='Transaction number' amount={transaction.transactionId.toString()} />
              <AlertItem name='Currency source' amount={transaction?.baseAsset} />
              <AlertItem name='Currency target' amount={transaction?.quoteAsset} />
              <AlertItem name='Source value' amount={transaction?.volumeExecuted?.toString() || '0'} />
              <AlertItem name='Target value' amount={transaction?.cost?.toString() || '0'} />
              <AlertItem name='Status' amount={transaction?.status} />

              <p className={classes.subTitle}>Fees</p>

              {/* <AlertItem name='Bank fee' amount={transaction?.sourceAsset} /> */}
              <AlertItem name='Network fee' amount={transaction?.exchangeFee.toString() +  ' ' + transaction.exchangeFeeCurrency} />
              {/* <AlertItem name='Target value' amount={transaction?.sourceAsset} /> */}
              <AlertItem name='Service fee' amount={transaction?.platformFee.toString() +  ' ' + transaction.platformFeeCurrency} />

              {/* <Button onClick={handleClose} style={{marginTop: 40}} fullWidth>View on block explorer</Button> */}
            </Card>
          )}
        </div>
      </DialogActions>
    </Dialog >
  )
};

export default AlertTransactionDetail;
